import { URI, UUID } from '@prestashopcorp/billing-cdc';

export class ContextShopInstance {
  constructor(
    public uuid: UUID,
    public domain: URI,
  ) {}
}
